import type { FC, ReactNode } from 'react';
import { Button, MenuDropdown, Tooltip } from '@george-labs.com/design-system';
import type { ItemPropTypes } from '@george-labs.com/design-system/types/components/Dropdown/MenuDropdownPropTypes';

import { useHighlightContext } from './HighlightContext';

interface Props {
    toggleButtonLabel: ReactNode;
    tooltip: ReactNode;
    dropdownItems: ItemPropTypes[];
    onDropdownItemSelect: (item: ItemPropTypes) => void;
    onDropdownOpen?: () => void;
}

export const HighlightDropdown: FC<Props> = ({
    toggleButtonLabel,
    tooltip,
    dropdownItems,
    onDropdownItemSelect,
    onDropdownOpen,
}) => {
    const { dataCy } = useHighlightContext();

    if (tooltip) {
        return (
            <Tooltip content={tooltip} tag="div">
                <Button
                    data-cy={`${dataCy}-highlight-button`}
                    variant={Button.VARIANT.SECONDARY}
                    size={Button.SIZE.SMALL}
                    className="my-2"
                    disabled
                >
                    {toggleButtonLabel}
                </Button>
            </Tooltip>
        );
    }
    return (
        <MenuDropdown
            items={dropdownItems}
            onOpen={onDropdownOpen}
            onSelect={onDropdownItemSelect}
            alignment={MenuDropdown.ALIGNMENT.CENTER}
            toggle={
                <Button
                    data-cy={`${dataCy}-highlight-button`}
                    variant={Button.VARIANT.SECONDARY}
                    size={Button.SIZE.SMALL}
                    className="my-2"
                >
                    {toggleButtonLabel}
                </Button>
            }
        />
    );
};
